import React from "react";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import {CruiseTimeOfDay} from "@/models/Enums";
import Localizer from "@/localization/Localizer";

import styles from "./TimeOfDay.module.scss";

import timeOfDayMorning from "./images/morning.png";
import timeOfDayDay from "./images/day.png";
import timeOfDayEvening from "./images/evening.png";

export interface ITimeOfDayProps {
}

interface ITimeOfDayState {
}

export default class TimeOfDay extends CruiseWizardPage<ITimeOfDayProps, ITimeOfDayState> {

    state: ITimeOfDayState = {
    };

    public async selectAsync(timeOfDay: CruiseTimeOfDay): Promise<void> {
        this.wizard.timeOfDay = timeOfDay;
        this.saveContext();
        await super.nextAsync();
    }

    public get canNext(): boolean {
        return (this.wizard.timeOfDay != null);
    }

    public get timeOfDay(): CruiseTimeOfDay | null {
        return this.wizard.timeOfDay;
    }

    public get title(): string | null {
        return (this.isFishing)
            ? Localizer.cruiseWizardTimeOfDayFishingTitle
            : (this.isHovercraft)
                ? Localizer.cruiseWizardTimeOfDayHovercraftTitle
                : Localizer.cruiseWizardTimeOfDayTitle;
    }

    public get supportsMorning(): boolean {
        return true;
    }

    public get supportsDay(): boolean {
        return true;
    }
    
    public get supportsEvening(): boolean {
        return (!this.isHovercraft);
    }

    public renderItem(timeOfDay: CruiseTimeOfDay, image: any, label: string): React.ReactNode {
        const selectedStyle: any = (timeOfDay == this.timeOfDay) && styles.selected;
        const mobileStyle: any = (this.mobile) && styles.mobile;
        return (
            <div className={this.css(styles.item, mobileStyle, selectedStyle)} onClick={() => this.selectAsync(timeOfDay)}>
                <div className={styles.image}>
                    <img src={image} alt={label}/>
                </div>
                <div className={styles.label}>
                    <div>
                        <span>{label}</span>
                    </div>
                </div>
            </div>
        );
    }
    

    public renderContent(): React.ReactNode {
        return (
            <div className={styles.timeOfDay}>

                <div className={this.css(styles.container, this.mobile && styles.mobile)}>

                    <div className={styles.row}>
    
                        { this.supportsMorning && this.renderItem(CruiseTimeOfDay.Morning, timeOfDayMorning, Localizer.cruiseWizardMorning) }
    
                        { this.supportsDay && this.renderItem(CruiseTimeOfDay.Day, timeOfDayDay, Localizer.cruiseWizardDay) }
    
                        { this.supportsEvening && this.renderItem(CruiseTimeOfDay.Evening, timeOfDayEvening, Localizer.cruiseWizardEvening) }
    
                    </div>
                    
                </div>

            </div>
        );
    }
}